import { useLingui } from '@lingui/react/macro'
import { Button } from 'designSystem/components/Button'
import { Spinner } from 'designSystem/components/Spinner'
import { Text } from 'designSystem/components/Text'
import { GlassPill } from 'features/knowledgeDocumentViewer/components/viewer/shared/glassSurface'
import { X } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

const CitedTextPill = styled(GlassPill)<{
  $placement: 'top-left' | 'top-right'
}>`
  position: absolute;
  top: 0.5rem;
  z-index: 10;
  padding-left: 0.75rem;
  ${({ $placement }) =>
    $placement === 'top-left' ? 'left: 0.5rem;' : 'right: 0.5rem;'}
`

type CitedTextBarProps = {
  isLocating: boolean
  isLocated: boolean
  onDismiss: () => void
  placement?: 'top-left' | 'top-right'
}

export function CitedTextBar({
  isLocating,
  isLocated,
  onDismiss,
  placement = 'top-right',
}: CitedTextBarProps) {
  const { t } = useLingui()
  const status = isLocating
    ? t`Locating cited text...`
    : isLocated
      ? t`Cited text`
      : t`Couldn't locate on page`

  return (
    <CitedTextPill $placement={placement} role='status'>
      {isLocating ? <Spinner size={12} /> : null}
      <Text variant='caption' weight='medium' color='default' wrap='nowrap'>
        {status}
      </Text>
      <Button
        type='button'
        variant='ghost'
        size='icon-sm'
        onClick={onDismiss}
        title={t`Clear highlight`}
        aria-label={t`Clear highlight`}>
        <X />
      </Button>
    </CitedTextPill>
  )
}
